module.exports = __webpack_public_path__ + "img/TrendUp.fcccd401.svg";